module.exports = function() {
  return new Worker(__webpack_public_path__ + "df9f0867c9369fd14241.worker.js");
};